export default {
  QUERY: 'query',
  TAG: 'tag',
  CATEGORY: 'category',
};



// WEBPACK FOOTER //
// ./src/shared/constants/search-query-fields.js